import api_fetch from '../utils/api_fetch';
import { storageHandler } from '../utils/storage_handler';

const userRoles = {
  getAllRoles: async function () {
    return (
      await api_fetch.get(
        `/v1/roles/`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        {}
      )
    ).json();
  },

  getUsers: async function () {
    return (
      await api_fetch.get(
        `/v1/users/`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        {}
      )
    ).json();
  },

  getById: async function (id) {
    return (
      await api_fetch.get(
        `/v1/roles/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        {}
      )
    ).json();
  },

  create: async function (body) {
    return (
      await api_fetch.post(
        `/v1/roles/`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        body
      )
    ).json();
  },

  update: async function (id, body) {
    return (
      await api_fetch.put(
        `/v1/roles/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        body
      )
    ).json();
  },

  delete: async function (id) {
    return (
      await api_fetch.delete(
        `/v1/roles/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        {}
      )
    ).json();
  },

  search: async function (query) {
    return (
      await api_fetch.get(
        `/v1/search-roles${query ? `?q=${encodeURIComponent(query)}` : ''}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        {}
      )
    ).json();
  },

  updateUserRole: async function (id, body) {
    return (
      await api_fetch.put(
        `/v1/users/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        body
      )
    ).json();
  }
};

export default userRoles;
